<template>
  <div>
    <v-dialog v-model="openDialog" max-width="1200px" persistent scrollable>
      <template v-slot:activator="{ on }">
        <mf-button label="Selecionar configuração de análise" v-on:click.native="on.click" />
      </template>
      <v-card>
        <v-card-title>
          <span class="mf-h6 primary-text">Selecionar configuração de análise</span>
        </v-card-title>
        <v-card-text>
          <div style="max-height: 700px; overflow-y: auto; overflow-x: hidden">
            <mf-search v-model="search" hide-details placeholder="Busque por configurações de análise" />
            <v-data-table :headers="headers" :items="items" :search="search" :loading="loading" :custom-items-per-page="10">
              <template #item="{ item }">
                <tr class="cursor-pointer" @click="toggleAnalyticsConfigurations(item)">
                  <td>
                    <v-simple-checkbox
                      :value="selectedAnalyticsConfigurationsIds.includes(item._id)"
                      color="primary"
                      :ripple="false"
                      @input="toggleAnalyticsConfigurations(item)"
                    />
                  </td>
                  <td class="nowrap-row">
                    {{ item.title }}
                  </td>
                  <td class="nowrap-row">
                    <v-tooltip v-if="item.filters.units.length > 0" right>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" style="cursor: auto" v-on="on">
                          {{ getUnits(item.filters) }}
                        </span>
                      </template>
                      <span v-for="(unit, index) in item.filters.units" :key="index" style="display: block">
                        {{ unit.name }}
                      </span>
                    </v-tooltip>
                    <span v-else> - </span>
                  </td>
                  <td>
                    <span>
                      {{ getDate(item.createdAt) }}
                    </span>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
          <mf-action-buttons
            class="mt-2"
            :primary-button="{
              text: 'Confirmar',
              action: save,
              isVisible: true,
            }"
            :extra-button="{
              text: 'Cancelar',
              action: closeDialog,
              isVisible: true,
            }"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-chip-group column active-class="primary--text">
      <v-chip
        v-for="(analyticConfiguration, index) in selectedAnalyticConfiguration"
        :key="`chip-${index}-loaded`"
        class="disabled-chip"
        small
        :close="!disabled"
        :ripple="false"
        @click:close="removeAnalyticConfiguration(index)"
      >
        <span>{{ analyticConfiguration.title }}</span>
      </v-chip>
    </v-chip-group>
  </div>
</template>

<script>
import { DateTime } from 'luxon'

import { getUnits, getPeriod } from '@/config/helpers.js'
import { QUERY_A_HUB_ANALYTICS_CONFIGURATIONS } from '@/modules/clientes/segmentation/graphql'
import { mapMutations } from 'vuex'
export default {
  name: 'CriterioSelectAnalyticConfiguration',
  props: {
    currentIndex: Number,
    values: {
      type: [Array, Number],
      default: () => {
        return []
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    initialValue: {
      type: [Array, Number],
      default: () => {
        return []
      },
    },
    componentParams: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      search: '',
      openDialog: false,
      loading: false,
      items: [],
      selectedAnalyticConfiguration: [],
      selectedAnalyticsConfigurationsIds: [],
    }
  },
  computed: {
    queryVariables() {
      return {
        type: this.componentParams.type,
        units: this.units ? this.units : [],
      }
    },
    headers() {
      return [
        {
          text: '',
          value: '_id',
          width: '10%',
          sortable: false,
        },
        {
          text: 'Título',
          value: 'title',
          width: '40%',
        },
        {
          text: 'Lojas',
          value: 'filters',
          width: '20%',
        },
        {
          text: 'Criado em',
          value: 'createdAt',
          width: '30%',
        },
      ]
    },
  },
  watch: {
    selectedAnalyticConfiguration: {
      deep: true,
      handler(value) {
        this.selectedAnalyticsConfigurationsIds = value.map(({ _id }) => _id)
        this.SET_SEGMENTATION_ANALYTIC_CONFIGURATION_IDS(this.selectedAnalyticsConfigurationsIds)
      },
    },
  },
  async mounted() {
    await this.getConfigurationData()
    if (this.selectedAnalyticConfiguration) {
      this.selectedAnalyticsConfigurationsIds = this.selectedAnalyticConfiguration.map(({ _id }) => _id)
      this.SET_SEGMENTATION_ANALYTIC_CONFIGURATION_IDS(this.selectedAnalyticsConfigurationsIds)
    }
    this.setInitialState()
    this.validate()
  },
  methods: {
    ...mapMutations(['SET_SEGMENTATION_ANALYTIC_CONFIGURATION_IDS']),
    getUnits,
    getPeriod,
    validate() {
      this.$emit('validate', { isValid: this.isValid(), currentIndex: this.currentIndex })
    },
    setInitialState() {
      if (this.initialValue && this.initialValue.length) {
        this.selectedAnalyticsConfigurationsIds = this.initialValue
        this.SET_SEGMENTATION_ANALYTIC_CONFIGURATION_IDS(this.selectedAnalyticsConfigurationsIds)
      }
      this.items.map((item) => {
        if (this.selectedAnalyticsConfigurationsIds.includes(item._id)) {
          this.selectedAnalyticConfiguration.push(item)
        }
      })
    },
    async getConfigurationData() {
      const { aHubAnalyticsConfigurations } = await this.$apollo
        .query({
          query: QUERY_A_HUB_ANALYTICS_CONFIGURATIONS,
          variables: this.queryVariables,
          fetchPolicy: 'no-cache',
        })
        .then(
          ({
            data: {
              aHubAnalyticsConfigurations: { aHubAnalyticsConfigurations },
            },
          }) => {
            return { aHubAnalyticsConfigurations }
          }
        )
      this.items = aHubAnalyticsConfigurations
    },
    getDate(date) {
      if (!date) return '-'
      return DateTime.fromISO(date.toString()).toFormat('dd/MM/yyyy')
    },
    toggleAnalyticsConfigurations(toggledAnalyticsConfiguration) {
      if (!this.selectedAnalyticConfiguration.length) {
        this.selectedAnalyticConfiguration = [toggledAnalyticsConfiguration]
        return
      }
      const isChecked = this.selectedAnalyticConfiguration.findIndex(
        (analyticsConfiguration) => analyticsConfiguration._id === toggledAnalyticsConfiguration._id
      )
      this.selectedAnalyticConfiguration = isChecked !== -1 ? [] : [toggledAnalyticsConfiguration]
    },
    removeAnalyticConfiguration(index) {
      this.selectedAnalyticConfiguration.splice(index, 1)
    },
    isValid() {
      return Boolean(this.selectedAnalyticConfiguration && this.selectedAnalyticConfiguration.length)
    },
    closeDialog() {
      this.openDialog = false
    },
    save() {
      this.$emit('input', {
        currentValue: this.selectedAnalyticConfiguration.map(({ _id }) => _id),
        currentChildren: this.values[0],
        currentIndex: this.currentIndex,
      })
      this.validate()
      this.closeDialog()
    },
  },
}
</script>
